import React from "react";
import {useFetch} from "../../../../hooks/useFetch";
import {useStore} from "../../../../hooks/useStore";
import {Link} from "react-router-dom/cjs/react-router-dom.min";
import {userTypes} from "../../../../constants/constants";
import {ResponsiveDataTable} from "../../../_defaultComponents/ResponsiveDataTable";

const columns = [
    {
        title: "Adı",
        dataIndex: "fullName",
        key: "fullName",
        onCell: () => ({ "data-label": "Adı" }),
        render: (fullName, record) => (
            <Link to={`/users/${record?._id}`}>{fullName || "-"}</Link>
        )
    },
    {
        title: "Kullanıcı Adı",
        dataIndex: "username",
        key: "username",
        onCell: () => ({ "data-label": "Kullanıcı Adı" }),
        render: username => username || "-"
    },
    {
        title: "Telefon Numarası",
        dataIndex: "phone",
        key: "phone",
        onCell: () => ({ "data-label": "Telefon Numarası" }),
        render: phone => phone || "-"
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        onCell: () => ({ "data-label": "Email" }),
        render: email => email || "-"
    },
    {
        title: "Kullanıcı Durumu",
        dataIndex: "disabled",
        key: "disabled",
        onCell: () => ({ "data-label": "Kullanıcı Durumu" }),
        render: disabled => (disabled ? "Pasif" : "Aktif")
    },
    {
        title: "Yetki",
        dataIndex: "role",
        key: "role",
        onCell: () => ({ "data-label": "Yetki" }),
        render: role => userTypes.find(type => type.value === role)?.name ?? "-"
    }
];

export const UsersTab = ({subcompanyId}) => {
    const stores = useStore();

    const [usersLoading, users] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.companyStore.getSubcompanyUsers.bind(null, {
            subcompanyId
        })
    });

    const dataSource = users?.data?.users ?? [];

    return (
        <div>
            <ResponsiveDataTable
                columns={columns}
                dataSource={dataSource}
                loading={usersLoading}
                rowKey={record => record?.id ?? record?._id}
                contentAlign="right"
            />
        </div>
    );
};
